import React from "react";

import { useCurrentService } from "Reducers/environment/hooks/useCurrentService";
import RouteInfos from "src/organization/common/components/RouteInfos/RouteInfos";
import Layout from "src/organization/pages/project/environment/services/components/Layout";
import Row from "src/organization/pages/project/environment/services/components/Row";
import ServiceNode from "src/organization/pages/project/environment/services/containers/ServiceNode";

import * as S from "./RouterOverview.styles";

import type { RouterTree } from "src/organization/common/containers/ServicesDisplay/util/serviceGraph";

const RouterOverview = () => {
  const grabMetadata = (currentService): RouterTree["metadata"] => {
    return {
      appName: "routes",
      kind: "router",
      ssi: !!currentService?.ssi?.enabled,
      cache: !!currentService?.cache?.enabled
    };
  };

  const currentService = useCurrentService();

  return (
    <React.Fragment>
      {Object.keys(currentService ?? {}).map(k => (
        <S.Wrapper key={k}>
          <Layout>
            <S.Title>
              <ServiceNode name="router" id={k.replace(/\/|:|\./g, "")} /> {k}
            </S.Title>
            <Row>
              <RouteInfos metadata={grabMetadata(currentService![k])} />
            </Row>
          </Layout>
        </S.Wrapper>
      ))}
    </React.Fragment>
  );
};

export default RouterOverview;
